/** 泛域名命中时运行时固定使用的路径前缀，与服务端 wildcardHost.js 保持一致 */
export const WILDCARD_PATH_PREFIX = '/page';
export const getRuntimeWildcardDomain = () => (window.GLOBAL_INFO?.runtimeWildcardDomain || '').trim().toLowerCase();
/**
 * 泛域名运行时跳转编辑端使用的 origin（如 https://wuji.woa.com）。
 * 未配置或未开启泛域名时返回空字符串。
 */
export const getRuntimeWildcardEditorHost = () => {
    if (!getRuntimeWildcardDomain())
        return '';
    const raw = (window.GLOBAL_INFO?.runtimeWildcardEditorHost || '').trim();
    if (!raw)
        return '';
    if (/^https?:\/\//i.test(raw))
        return raw.replace(/\/+$/, '');
    return `https://${raw.replace(/\/+$/, '')}`;
};
/** 泛域名预览灰度范围：按 projectId 首字母灰度，约覆盖 50%（13/26） */
const WILDCARD_PREVIEW_PROJECT_ID_PREFIXES = ['w', 'b', 't', 'k', 'd', 'z', 'a', 'x', 'u', 's', 'y', 'p', 'o'];
/**
 * 管理台的访问 / 预览入口是否使用泛域名
 *
 * 与 runtimeWildcardDomain 分工：后者由 server 下发，决定运行时能否通过泛域名访问；
 * 本判断只作用于管理台生成访问链接的场景，当前按 projectId 前缀灰度，其余应用回落原有链路
 */
export const isWildcardPreviewEnabled = (projectId) => {
    // 泛域名 host 会被 DNS 小写化，而 projectId 可能含大写，故统一按小写比较
    const id = (projectId || '').trim().toLowerCase();
    return !!id && WILDCARD_PREVIEW_PROJECT_ID_PREFIXES.some(prefix => id.startsWith(prefix));
};
export const parseWildcardHost = (host, wildcardDomain = getRuntimeWildcardDomain()) => {
    const wd = (wildcardDomain || '').trim().toLowerCase();
    if (!wd)
        return null;
    const h = (host || '').toLowerCase().split(':')[0];
    const re = new RegExp(`^([^.]+)\\.${wd.replace(/\./g, '\\.')}$`);
    const m = h.match(re);
    if (!m)
        return null;
    const sub = m[1];
    const idx = sub.lastIndexOf('-');
    let projectId;
    let env;
    if (idx === -1) {
        projectId = sub;
        env = 'prod';
    }
    else {
        projectId = sub.slice(0, idx);
        env = sub.slice(idx + 1);
    }
    if (!projectId || !env)
        return null;
    return { projectId, env, pathPrefix: WILDCARD_PATH_PREFIX };
};
export const isWildcardHost = (host = location.host) => !!parseWildcardHost(host);
/**
 * 拼接泛域名 host，不受预览灰度约束
 *
 * 管理台的访问 / 预览链接请改用 `getWildcardRuntimeBase`，以便受 `isWildcardPreviewEnabled` 约束；
 * 直接调用仅限运行时自身的场景（导航栏环境切换、AI 页面分享面板）
 */
export const buildWildcardHost = ({ projectId, env, wildcardDomain = getRuntimeWildcardDomain(), port = '', }) => {
    const wd = (wildcardDomain || '').trim().toLowerCase();
    const pid = (projectId || '').trim();
    const targetEnv = (env || '').trim();
    if (!wd || !pid || !targetEnv)
        return null;
    const sub = targetEnv === 'prod' ? pid : `${pid}-${targetEnv}`;
    const purePort = `${port || ''}`.trim();
    const host = `${sub}.${wd}`.toLowerCase();
    return purePort ? `${host}:${purePort}` : host;
};
